<!-- 注册登录 -->
<template>
  <div>
    <div class="header">
      <div class="user" @click="$router.go(-1)">
        <Icon type="ios-arrow-back" size="22" />
      </div>
    </div>
    <div class="login">
      <h3>忘记密码</h3>
      <Form
        ref="formItems"
        style="margin-top: 30%"
        :model="formItems"
        :rules="ruleInfo"
        :label-width="0"
      >
        <FormItem  prop="phone" v-if="list_top == 0">
          <Input v-model="formItems.phone" placeholder="请输入手机号">
            <Select v-model="select1" slot="prepend" style="width: 80px">
              <Option value="1">+86</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem
          ref="formItems.code"
          :model="formItems.code"
          :rules="ruleInfos"
          v-if="list_top == 1"
        >
          <Input
            :prop="code"
            v-model="formItems.code"
            placeholder="输入验证码"
            style="width: 200px; float: left"
          />
          <Button
            v-show="codeList"
            @click="getCode('formItems')"
            size="large"
            type="primary"
            style="float: right"
            >获取验证码</Button
          >
          <Button v-show="!codeList" size="large" type="primary" style="float: right"
            >{{ times }}秒</Button
          >
        </FormItem>

        <FormItem prop="passList" v-if="list_top == 2">
          <Input type="password" v-model="formItems.passList" placeholder="请设置新密码">
          </Input>
        </FormItem>
      </Form>

      <div v-if="list_top == 0" class="register" @click="login('formItems')">下一步</div>
      <div v-if="list_top == 1" class="register" @click="next_list">下一步</div>
      <div v-if="list_top == 2" class="register" @click="nextlives">修改成功</div>
    </div>
    <VerifyCode
      ref="verifyCode"
      :boxShow="show"
      :phone="formItems.phone"
      @success="handleVerifySuccess"
      @close="handleVerifyClose" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  email,
  realName,
  password,
  select,
  upload,
  empty,
  phone,
  identity,
  verificationCode,
  pws,
  selectcity,
} from "@/core/charm/charm";
import VerifyCode from "@/components/verifyCodeMobile.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {VerifyCode},
  data() {
    //这里存放数据
    return {
      select1: "1",
      value12: "",
      code: "", // 验证码
      switch: 1,
      list_top: 0,
      formItems: {
        phone: "",
        code: "",
        passList: "",
      },
      ruleInfos: {
        code: verificationCode(),
      },
      ruleInfo: {
        phone: phone("你的手机号"),
        // passList: empty(),
        // code: empty(),
        // passwords: password("你的密码"),
        // validate: verificationCode("你的验证码"),
      },
      times: "", //验证码获取时间
      codeList: true,
      count: null,
      verifyWidth: 400,
      isVerify: false,
      show: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleVerifySuccess() {
      this.show = false;
      this.yanzheng();
    },
    handleVerifyClose () {
      this.show = false;
    },
    login(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.list_top = 1;
        } else {
          this.$Message.error("请完善您的信息!");
        }
      });
    },
    nextlives() {
      var data = {
        mobile: this.formItems.phone,
        validateCode: this.formItems.code,
        pwd: this.formItems.passList,
      };
      this.$apis.manage.foget(data).then((res) => {
        if (res.messageType == "Success") {
          this.$Message.success(res.resultDesc);
          this.$router.push({
            path: "/login",
          });
        } else {
          this.$Message.error(res.resultDesc);
        }
      });
    },
    next_list() {
      this.$refs.formItems.validate((valid)  => {
        if(!valid)return
        var list = /^[0-9]{6}$/;
        if (list.test(this.formItems.code)) {
          this.list_top = 2;
        } else {
          this.$Message.error("验证码格式输入有误");
        }
      })
    },
    async getCode(name) {
      // 校验手机号是否注册
      const res = await this.$apis.manage.accountIsExist({
        account: this.formItems.phone,
      })
      if(res.data){
        return this.$Message.error("该手机号未被注册"); 
      }

      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.times) return
          this.show = true;
        }
      });
    },
    yanzheng() {
      var data = {
        phone: this.formItems.phone,
        adapter: "retrieve_pwd",
      };
      this.$apis.manage
        .regiteList(data)
        .then((res) => {
          if (res.messageType == "Success") {
            this.$Message.success(res.resultDesc);
            const TIME_COUNT = 60;
            this.times = TIME_COUNT;
            this.codeList = false;
            this.times = 60;
            var count = setInterval(() => {
              this.times--;
              if (this.times <= 0) {
                this.codeList = true;
                clearInterval(count);
              }
            }, 1000);
          } else {
            this.$Message.error(res.resultDesc);
          }
        })
        .catch((err) => {});
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.verifyWidth = document.getElementsByClassName('ivu-form-item')[0].clientWidth
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.header {
  height: 52px;
  line-height: 52px;
  text-align: center;
  padding: 0 18px;
  display: flex;
  justify-content: flex-start;
  background-color: #fff;
  //margin-bottom:20px;
  .user {
    display: flex;
    // justify-content: space-around;
    align-items: center;
    width: 100px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
//@import url(); 引入公共css类
.register {
  width: 100%;
  height: 53px;
  background: #2150cb;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 53px;
  text-align: center;
  margin-top: 62px;
}

.account {
  width: 100%;
  height: 53px;
  border-radius: 4px;
  color: #2150cb;
  font-size: 16px;
  line-height: 53px;
  text-align: center;
  margin-top: 10px;
}
.text {
  height: 13px;
  margin-top: 15px;
  font-size: 13px;
  font-weight: 400;
  color: #b6b6b6;
}
.code {
  height: 40px;
  border-bottom: 1px solid #e6e6e6;
  margin-top: 30px;
}
.login {
  padding: 0 37px 0 37px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}
.phone {
  margin-top: 110px;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
  height: 40px;
}
h3 {
  text-align: center;
  //margin-top: 20px;
  font-size: 18px;
  font-weight: 400;
}
/deep/.ivu-input-group-append,
/deep/.ivu-input-group-prepend {
  padding: 4px 7px;
  font-size: inherit;
  font-weight: 400;
  line-height: 1;
  color: #515a6e;
  text-align: center;
  background-color: #fff;
  border: none;
  border-radius: 4px;
}

/deep/.ivu-input {
  border: none !important;
  font-size: 16px;
}

/deep/.ivu-input:focus {
  outline: none;
  border: none;
  box-shadow: 0 0 0 2px transparent;
}
/deep/.ivu-select-placeholder {
  font-size: 16px !important;
}

/deep/.ivu-input-group .ivu-input,
/deep/.ivu-input-group .ivu-input-inner-container {
  width: 100%;
  float: left;
  margin-bottom: 0;
  position: relative;
  z-index: 2;
  font-size: 16px;
}
/deep/.ivu-btn-primary {
  color: #fff;
  background-color: #2150cb;
  border-color: #2150cb;
}
</style>
